/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import TOOLBOX_TABLE from "../toolbox/TOOLBOX_TABLE";
import SINI_DATA from "../sini_data/SINI_DATA";
import SINI_WRAPER from "./SINI_WRAPER";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/
import icon_data from "../../Assets/svg/icon_data_new.svg";
import icon_sini from "../../Assets/svg/icon_sini.svg";
import icon_toolbox from "../../Assets/svg/icon_tool_new.svg";
import { set_value_toolbox } from "../../App/actions/toolboxActions";

/*FUNCTION*/

/*DATA*/

/*CONST*/

const SIDEBAR_CONTENT = ({
  layer,
  properties,
  set_value_properties,
  set_value_layer,
  toolbox,
  set_value_toolbox,
}) => {
  const { statistic_mode, map_object, draw_object } = layer;
  const { sidebar_height, is_mobile, mode_map } = properties;
  const { mode_toolbox, mode_draw, last_saved_feature_uuid } = toolbox || {};

  let tabs = [
    {
      value: "data",
      label: "DATA",
      icon: icon_data,
      alt: "Icon Data",
    },
    {
      value: "sini",
      label: "SINI",
      icon: icon_sini,
      alt: "Icon Sini",
    },
    {
      value: "toolbox",
      label: "TOOL",
      icon: icon_toolbox,
      alt: "Icon Toolbox",
    },
  ];

  if (mode_map !== "editor") {
    tabs = tabs.filter((item) => item.value !== "sini");
  }

  let max_height_css;
  if (sidebar_height === "pc") {
    max_height_css = `calc(100vh - 101px)`;
  } else {
    max_height_css = `calc(${sidebar_height}px - 60px)`;
  }

  let final_tabs = tabs;
  let sidebar_content;

  if (statistic_mode === "toolbox") {
    sidebar_content = <TOOLBOX_TABLE />;
  } else if (statistic_mode === "sini") {
    sidebar_content = (
      <div style={{ padding: "10px" }}>
        <SINI_WRAPER />
      </div>
    );
  } else {
    sidebar_content = (
      <div style={{ padding: "10px" }}>
        <SINI_DATA />
      </div>
    );
  }

  const setStatisticModeFunc = (value) => {
    if (is_mobile) {
      set_value_properties({
        key: "sidebar_right_status",
        value: true,
      });
    }

    if (
      mode_toolbox &&
      mode_draw &&
      value === "toolbox" &&
      map_object &&
      draw_object
    ) {
      set_value_layer({
        key: "draw_state_platform",
        value: "toolbox",
      });
      set_value_layer({
        key: "geometryStatus",
        value: false,
      });

      draw_object.changeMode("simple_select");
      map_object.getCanvas().style.cursor = "crosshair";
      draw_object.changeMode(mode_draw);
    }

    const features = toolbox?.[mode_toolbox] || [];
    let last_saved_feature_uuid_index;
    if (last_saved_feature_uuid === "")
      last_saved_feature_uuid_index = Infinity;
    else if (last_saved_feature_uuid === "start")
      last_saved_feature_uuid_index = -1;
    else {
      last_saved_feature_uuid_index = features.findIndex(
        (f) => f.properties.uuid === last_saved_feature_uuid,
      );
    }

    if (
      value !== "toolbox" &&
      mode_toolbox &&
      last_saved_feature_uuid_index < features.length
    ) {
      set_value_toolbox({
        key: "modal_cancel_confirmation",
        value: {
          is_open: true,
          is_back_active: false,
          tab_value: value,
        },
      });
      return;
    }

    set_value_layer({
      key: "statistic_mode",
      value: value,
    });
  };

  return (
    <main
      style={{
        backgroundColor: "white",
        borderRadius: "9px",
        width: is_mobile ? "100%" : "289px",
        maxWidth: "100vw",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* TAB CONTAINER */}
      <div
        style={{
          width: "100%",
          display: "flex",
          borderBottom: "1px solid #ddd",
        }}
      >
        {final_tabs.map((tab) => {
          const isActive = statistic_mode === tab.value;
          return (
            <div
              key={tab.value}
              onClick={() => setStatisticModeFunc(tab.value)}
              data-mapid="clickTabIcon"
              style={{
                flex: 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px 0px", // Decreased from 12px to 4px
                minHeight: "24px", // Decreased from 30px to 24px
                borderBottom: isActive
                  ? "3px solid #000"
                  : "3px solid transparent",
                color: isActive ? "#000" : "#555",
                fontWeight: isActive ? "bold" : "normal",
                fontSize: "12px", // Slightly smaller font for shorter tabs
                transition: "all 0.2s ease-in-out",
                whiteSpace: "nowrap",
              }}
            >
              <span className="text_medium">{tab.label}</span>
            </div>
          );
        })}
      </div>

      <section
        style={{
          overflowY: "auto",
          maxHeight: max_height_css,
        }}
      >
        <div
          style={{
            width: "100%",
            marginBottom: "150px",
          }}
        >
          {sidebar_content}
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
  toolbox: state.toolbox,
});

export default connect(mapStateToProps, {
  set_value_properties,
  set_value_layer,
  set_value_toolbox,
})(SIDEBAR_CONTENT);
